<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : pickingReturn.pkid > 0 ? '编辑' : '新建'"
      width="1200px"
      class="pickingReturnEdit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="pickingReturn"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="pickingReturn.pkid > 0" :span="12">
          <el-form-item label="领料单号" prop="billNo">
            <el-input v-model="pickingReturn.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="退料仓" prop="locationName">
            <el-input
                v-model="pickingReturn.warehouseLocationName"
                :disabled="pickingReturn.pkid > 0"
                readonly
                placeholder="请选择仓位">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="pickingReturn.pkid > 0"
                  @click="$refs.locationSelect.open()"/>
            </el-input>
            <warehouse-location-select ref="locationSelect" @select="locationSelect"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联单据编号" prop="relBillNo">
            <el-input
                v-model="pickingReturn.relBillNo"
                :disabled="pickingReturn.pkid > 0"
                readonly
                placeholder="请选择关联单据编号">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="pickingReturn.pkid > 0"
                  @click="$refs.productionOrderSelect2.open()"/>
            </el-input>
            <production-order-select2 ref="productionOrderSelect2" @select="productionOrderSelect2"/>
          </el-form-item>
        </el-col>
        <el-col v-if="pickingReturn.status === 2" :span="12">
          <el-form-item label="领料时间" prop="requireDate">
            <el-input v-model="pickingReturn.requireDate" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="pickingReturn.pkid > 0" :span="12">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="pickingReturn.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="pickingReturn.pkid > 0" :span="12">
          <el-form-item label="制单时间" prop="createTime">
            <el-input v-model="pickingReturn.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="pickingReturn.pkid > 0" :span="12">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="pickingReturn.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input v-model="pickingReturn.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">退料明细</div>
      <el-table
          class="tableBox"
          :data="pickingReturn.outStockBillDetailVOS"
          border
          @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"/>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
        <el-table-column prop="materialName" align="left" label="物料名称"/>
        <el-table-column align="center" label="收料仓" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.locationName" readonly placeholder="请选择收料仓">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.FLlocationSelect.open();setIndex(scope.$index)"/>
            </el-input>
            <warehouse-location-select ref="FLlocationSelect" @select="FLlocationSelect"/>
          </template>
        </el-table-column>
        <el-table-column prop="unitName" align="center" label="单位" width="60"/>
        <!-- <el-table-column prop="price" align="center" label="单价" width="60"/> -->
        <el-table-column align="center" label="数量" width="160" prop="quantity"/>
        <el-table-column align="center" label="实退数量" width="160" prop="actualQuantity">
          <template slot-scope="scope">
            <el-input v-model="scope.row.actualQuantity" clearable placeholder="请输入退"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注"
            width="120"
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" placeholder="请输入"/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import ProductionOrderSelect2 from "@/views/ProductionManagement/ProductionOrder/ProductionOrderSelect2";
  import WarehouseLocationSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";

  export default {
    name: "PickingReturnEdit",
    components: {ProductionOrderSelect2, WarehouseLocationSelect},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        index: 0,
        pickingReturn: {
          outStockType: 2,
          pkid: 0,
          billNo: "",
          relBillNo: "",
          relBillId: "",
          requireDate: "",
          status: "",
          statusName: "",
          creatorName: "",
          createTime: "",
          note: "",
          warehouseLocationName: "",
          warehouseLocationNo: "",
          destLocationId: "",
          outStockBillDetailVOS: [],
        },
        outStockBillDetailVOS: [],
        multipleSelection: [],
        qty: [],
        ruleValidate: {
          warehouseLocationName: {required: true, message: "请选择领料仓位", trigger: "change"},
          FLlocationName: {required: true, message: "请选择收料仓位", trigger: "change"},
          quantity: {required: true, trigger: "blur"},
          relBillNo: {required: true, message: "请选择关联单号", trigger: "change"},
        },
      };
    },
    methods: {
      open(row, disabled) {
        console.log(row);
        this.dialogVisible = true;
        if (row) {
          this.pickingReturn.pkid = row.pkid;
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
        // this.outStockBills.outStockBillDetailVOS = val;
      },


      // 根据出货订单id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `pickingListBacks/${this.pickingReturn.pkid}`)
          .then((resp) => {
            console.log(resp);
            if (resp.success) {
              this.pickingReturn = Object.assign(this.pickingReturn, resp.data);
              this.outStockBillDetailVOS = this.pickingReturn.outStockBillDetailVOS;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      setIndex(index) {
        this.index = index;
      },

      //仓位选择
      locationSelect(row) {
        this.pickingReturn.warehouseLocationName = row.warehouseLocationName;
        this.pickingReturn.warehouseLocationNo = row.warehouseLocationNo;
        this.pickingReturn.destLocationId = row.pkId;
      },

      FLlocationSelect(row) {
        this.outStockBillDetailVOS[this.index].locationName = row.warehouseLocationName;
        this.outStockBillDetailVOS[this.index].locationId = row.pkId;
      },

      //选择关联单号
      productionOrderSelect2(row) {
        this.pickingReturn.relBillNo = row.billNo;
        this.pickingReturn.relBillId = row.pkid;
        this.pickingReturn.warehouseLocationName = row.warehouseLocationName;
        this.pickingReturn.warehouseLocationNo = row.warehouseLocationNo;
        this.getOrderDetail(row.pkid);
      },

      //根据单号获取明细
      getOrderDetail(id) {
        this.$http.get("basic", `pickingListBacks/getBackStock/${id}`).then((res) => {
          this.pickingReturn = res.data;
          this.pickingReturn.outStockBillDetailVOS = res.data.outStockBillDetailVOS;
          this.outStockBillDetailVOS = res.data.outStockBillDetailVOS;
        });
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.multipleSelection.length) {
              this.$confirm("请勾选明细", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            let flag = false;
            this.multipleSelection.forEach(item => {
              if (!item.locationName) {
                flag = true;
              }
            });
            if (flag) {
              this.$confirm("请选择收料仓", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.pickingReturn.outStockBillDetailVOS = this.multipleSelection;
            this.submitLoading = true;
            this.$http
              .save("basic", "pickingListBacks", this.pickingReturn)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.pickingReturn.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.pickingReturnEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.pickingReturnEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.pickingReturnEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.pickingReturnEdit .el-divider--horizontal {
  margin: 10px 0;
}

.pickingReturnEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
